function FilterContainer({
  selectedYear,
  setSelectedYear,
  selectedMonth,
  setSelectedMonth,
  searchQuery,
  setSearchQuery,
  yearRanges,
  monthOptions,
  totalCount,
}) {
  return (
    <div className="row tabs-dynamic">
      <div className="col-xxl-3 col-xl-3 col-lg-6 col-12">
        <div className="count-val">
          <p>Total Categories: {totalCount}</p>
        </div>
      </div>

      <div className="col-xxl-3 col-xl-3 col-lg-6 col-12">
        <div className="month-selection">
          <select
            value={selectedYear}
            onChange={(e) => setSelectedYear(e.target.value)}
            className="yearSelection">
            {yearRanges?.map((yr) => (
              <option key={yr} value={yr}>
                {yr}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="col-xxl-3 col-xl-3 col-lg-6 col-12">
        <div className="month-selection">
          <select
            value={selectedMonth}
            onChange={(e) => setSelectedMonth(e.target.value)}
            className="monthSelect">
            {monthOptions.map((month, index) => (
              <option key={index} value={month}>
                {month}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="col-xxl-3 col-xl-3 col-lg-6 col-12">
        <div className="searchBox">
          <input
            type="text"
            id="myInput"
            name="name"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="Search Here..."
          />
        </div>
      </div>
    </div>
  );
}
export default FilterContainer;
